





























import { defineComponent } from "@vue/composition-api";
import BaseIcon from "@/components/BaseIcon";
import BaseImage from "@/components/BaseImage";
import BaseSpinner from "@/components/BaseSpinner";

export default defineComponent({
  name: "ImagePreview",
  components: { BaseIcon, BaseImage, BaseSpinner },
  props: {
    size: { type: String, default: "122px" },
    src: { type: String, required: true },
    alt: { type: String },
    loading: { type: Boolean, default: false },
    remove: { type: Boolean, default: false },
  },
});
